/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Grid, Skeleton } from '@coursera/cds-core';

import _t from 'i18n!nls/onboarding-common';

const SelectQuestionLoadingState = () => {
  const generateSkeletons = (count: number) => {
    return Array.from({ length: count }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Grid item key={`loading-skeleton-${index}`} xs={12} sm={6} md={3}>
        <Skeleton css={{ borderRadius: '32px' }} variant="rect" height={38} aria-label={_t('Loading option')} />
      </Grid>
    ));
  };

  return (
    <section
      role="status"
      aria-label={_t('Loading question options')}
      aria-live="polite"
      data-testid="role-select-loading"
    >
      <Grid container spacing={8}>
        {generateSkeletons(4)}
      </Grid>
    </section>
  );
};

export default SelectQuestionLoadingState;
